import { DEX_TYPE } from "@/config/constants";

export const textTypes = {
    TAGLINE_TEXT: "TAGLINE_TEXT",
    DEX_NAME: "DEX_NAME"

};


export const DEX_LOCALE = {
    [DEX_TYPE.SGTRADEX]: {
        [textTypes.DEX_NAME]: "TRADE",
        [textTypes.TAGLINE_TEXT]: "Making your trade data sharing easy and secure"

    },
	[DEX_TYPE.SGBUILDEX]: {
        [textTypes.DEX_NAME]: "BUILDEX",
        [textTypes.TAGLINE_TEXT]: "Making your building and construction data sharing easy and secure",
    },
    [DEX_TYPE.SGHEALTHDEX]: {
        [textTypes.DEX_NAME]: "HEALTHCARE",
        [textTypes.TAGLINE_TEXT]: "Making your healthcare data sharing easy and secure"

    }
}
